<template>
  <component :is="container">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </component>
</template>

<script lang="ts" setup>
  import { useTechnicalHead } from '~/domains/head/technical/services/useTechnicalHead';

  // Тут мы включаем layout-ы через NuxtLayout/NuxtPage
  // Однако мы не можем вынести сюда любые стили/компоненты
  // Потому что app.vue общий для сайта и для AMP версии
  // Поэтому тут нужно грузить AppContainer асинхронно
  const AppContainer = defineAsyncComponent(() => import('~/containers/AppContainer.vue'));
  const AmpAppContainer = defineAsyncComponent(() => import('~/containers/AppContainer.amp.vue'));

  const nuxtApp = useNuxtApp();
  const container = computed(() => (nuxtApp.$isAMP ? AmpAppContainer : AppContainer));

  useTechnicalHead();
</script>
